import { render, staticRenderFns } from "./custom-type2.vue?vue&type=template&id=1678363e&scoped=true"
import script from "./custom-type2.vue?vue&type=script&lang=js"
export * from "./custom-type2.vue?vue&type=script&lang=js"
import style0 from "./custom-type2.vue?vue&type=style&index=0&id=1678363e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1678363e",
  null
  
)

export default component.exports